/**
 * wishlistHistory — persists wishlist tokens in localStorage so the
 * home page can show "My Wish Lists" (both created and received).
 *
 * Each entry stores just enough for a card: token, label, item count, date.
 * Capped at 20 entries (oldest pruned).
 */

const STORAGE_KEY = 'dukkan_wishlists'
const MAX_ENTRIES = 20

export interface WishlistHistoryEntry {
  token: string
  shopName: string
  itemCount: number
  multiShop: boolean
  createdAt: string          // ISO string
  type: 'created' | 'received'
  senderName?: string
  title?: string
}

/** Read all saved entries (newest first). */
export function getWishlistHistory(): WishlistHistoryEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const arr: WishlistHistoryEntry[] = JSON.parse(raw)
    return arr.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
  } catch {
    return []
  }
}

/** Save or update a wishlist entry. De-duplicates by token. */
export function saveWishlistToken(entry: WishlistHistoryEntry): void {
  try {
    const existing = getWishlistHistory().filter((e) => e.token !== entry.token)
    const updated = [entry, ...existing].slice(0, MAX_ENTRIES)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  } catch {
    // localStorage full or unavailable — ignore
  }
}

/** Remove a single entry by token. */
export function removeWishlistToken(token: string): void {
  try {
    const updated = getWishlistHistory().filter((e) => e.token !== token)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  } catch {
    // ignore
  }
}
